







































import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class NewGameDialog extends Vue {

    @Prop()
    private showNewGameDialog: boolean;

    private closeNewGameDialog() {
        this.$emit('close-new-game-dialog')
    }

    private newGame() {
        this.$emit('new-game')
    }
}
